<template>
  <v-container>
    <h1 class="primary--text text-center mb-10">Our customers say it best.</h1>
    <v-row>
      <v-col cols="12" md="6" v-for="(comment, i) in comments" :key="i">
        <v-card outlined class="mx-auto">
          <v-card-text>
            <v-icon class="primary--text" large>mdi-format-quote-open</v-icon
            ><br />
            <p class="ml-8 mt-4">
              {{ comment.text }}
            </p>

            <p class="text-right mt-4 mr-2">
              - {{ comment.author }}<b>, {{ comment.address }}</b
              >.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import comments from "../api/comments.js";

export default {
  name: "Comments",

  data: () => ({
    comments,
  }),
};
</script>
